import React from 'react';
import { string, bool } from 'prop-types';
import styled from 'styled-components';
import ArrowBlue from 'TMComponents/Icons/ArrowBlue';
import { spacing } from 'TMDesignSystem/spacing';
import { breakpoints } from 'TMConstants';

const ArrowIcon = styled(ArrowBlue)`
    width: 16px;
    height: 15px;
    transition: transform 0.2s ease;
    flex-shrink: 0;
    margin-left: ${spacing.medium};

    @media (min-width: ${breakpoints.mobileTablet}px) {
        width: 20px;
        height: 19px;
    }

    path {
        fill: ${({ theme }) => theme.colorSystem.primary[1]};
        transition: fill 0.2s ease;
    }
`;

const StyledLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
    padding: ${spacing.mediumLarge} 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: -0.35px;
    color: ${({ theme }) => theme.colorSystem.primary[1]};
    transition: color 0.2s ease;
    border-bottom: 1px solid
        ${({ theme }) => theme.colorSystem.UIElements[6]};
    width: 100%;

    @media (min-width: ${breakpoints.mobileTablet}px) {
        font-size: 16px;
        line-height: 24px;
        padding: ${spacing.large} 0;
    }

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    &:hover {
        color: ${({ theme }) => theme.colorSystem.primary[4]};
        text-decoration: none;

        svg {
            transform: translateX(4px);

            path {
                fill: ${({ theme }) => theme.colorSystem.primary[4]};
            }
        }
    }
`;

const ArrowLink = ({ text, href, external }) => (
    <StyledLink href={href} external={external}>
        {text}
        <ArrowIcon />
    </StyledLink>
);

ArrowLink.propTypes = {
    text: string.isRequired,
    href: string.isRequired,
    external: bool
};

ArrowLink.defaultProps = {
    external: false
};

export default ArrowLink;
